import { ReactComponent as Warning } from '@basqet-dashboard/common/assets/icons/warning.svg';
import { Button } from '@basqet-dashboard/common/components/';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import React from 'react';

const PayoutErrorView = () => {
  const { navigateTo } = useNavigateTo();

  return (
    <div className="card">
      <div className="process-info">
        <Warning role="img" />
        <p className="card__text">
          There was an error processing your payout. Please try again or contact support.
        </p>
        <Button isFull type="submit" onClick={() => navigateTo('/payouts')}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export { PayoutErrorView };
